<template>
    <div class="AchievementsView divide-y divide-gray-400 dark:divide-default">
        <CAchievementBox
            v-for="(item, index) in items"
            :key="index"
            class="py-5"
            :class="{ 'pt-0': index === 0, 'pb-0': index === items.length - 1 }"
        >
            <template #icon>
                <CIcon name="winnings" />
            </template>

            <template #title>
                {{ item.achievement }}
            </template>

            <template #year>
                {{ item.year }}
            </template>

            <template v-if="item.org" #subtitle>
                {{ item.org }}
            </template>

            <template v-if="item.desc" #description>
                <span v-html="item.desc" />
            </template>
        </CAchievementBox>
    </div>
</template>

<script setup lang="ts">
import { Achievement } from '#shared/types/User'

defineProps<{
    items?: Achievement[]
}>()
</script>